const ROLE_TO_AUTHOR = {
    assistant: 'bot',
    user: 'user'
};

const memoryChatMapper = {
    toDomain(data) {
        return {
            messages: (data.messages || []).map((message, index) => ({
                id: message.id || `${message.role}-${index}`,
                author: ROLE_TO_AUTHOR[message.role] || message.role,
                text: message.content
            })),
            isChatFinished: Boolean(data.isChatFinished)
        };
    }
};

export {
    memoryChatMapper
};
